import { render, staticRenderFns } from "./PartnerFormOptionalData.vue?vue&type=template&id=477d6330&scoped=true&"
import script from "./PartnerFormOptionalData.vue?vue&type=script&lang=ts&"
export * from "./PartnerFormOptionalData.vue?vue&type=script&lang=ts&"
import style0 from "./PartnerFormOptionalData.vue?vue&type=style&index=0&id=477d6330&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477d6330",
  null
  
)

export default component.exports